module.exports = __webpack_public_path__ + "static/img/5.6237098.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/companys/5.png
// module id = SFxI
// module chunks = 1